/** BigInt-safe stringify used by the table's fallback search; returns '' on failure. */
export const safeStringify = (value: unknown): string => {
  try {
    return JSON.stringify(value, (_k, v) => (typeof v === 'bigint' ? v.toString() : v)) || ''
  } catch {
    return ''
  }
}
